import {
  UserRemoveIcon,
  DesktopComputerIcon,
  ExclamationIcon,
} from "@heroicons/react/outline";
import { useContext, useState } from "react";
import ReactModal from "react-modal";

import { ApiService } from "pwapi";

import { logout } from "shared/actions/authActions";
import { selectFeatureFlag } from "shared/reducers/sysReducer";
import { AlreadyLoadingError } from "shared/utils/asyncActions";

import { useAppDispatch, useAppSelector } from "app/hooks";
import SelectedStationContext from "app/SelectedStationContext";
import StationSelection from "ui/components/StationSelection";

const ChangeStationModal = ({
  isOpen,
  close,
  canChangeLabs,
}: {
  isOpen: boolean;
  close: () => void;
  canChangeLabs: boolean;
}) => {
  const selectedStation = useContext(SelectedStationContext);
  const defaultStationId = parseInt(
    localStorage.getItem("selectedStationId") || ""
  );

  const setStationId = (id: number) => {
    sessionStorage.setItem("selectedStationId", `${id}`);
    window.location.href = "/";
  };

  const setLabId = (id: number) => {
    if (
      window.confirm(
        `Please close or refresh any other ${window.location.host} tabs you have open.`
      )
    ) {
      localStorage.setItem("selectedLabId", `${id}`);
      localStorage.removeItem("selectedStationId");
      sessionStorage.removeItem("selectedStationId");
      window.location.reload();
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      style={{
        content: {
          maxWidth: "800px",
          margin: "0 auto",
          position: "relative",
          inset: "initial",
        },
        overlay: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: "var(--zIndexModal)",
        },
      }}
      onRequestClose={close}
    >
      <StationSelection
        {...selectedStation}
        setStationId={setStationId}
        setLabId={setLabId}
        hideLabSelection={!canChangeLabs}
        defaultStationId={defaultStationId}
      />
    </ReactModal>
  );
};

const StationButtons = () => {
  const dispatch = useAppDispatch();

  const canChangeLabs = useAppSelector((state) =>
    selectFeatureFlag(state, "canChangeLabs")
  );
  const canChangeStations =
    useAppSelector((state) => selectFeatureFlag(state, "canChangeStations")) ||
    canChangeLabs;
  const hasErrorButton = useAppSelector((state) =>
    selectFeatureFlag(state, "hasErrorButton")
  );

  const [isChangingStation, setIsChangingStation] = useState(false);

  return (
    <div className="StationRefresh">
      {hasErrorButton && (
        <div className="error-buttons-wrapper">
          <button>
            <ExclamationIcon />
          </button>
          <div className="error-buttons-menu">
            <ul>
              <li>
                <button
                  onClick={() => {
                    throw new Error("Error button clicked");
                  }}
                >
                  JS Error
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    throw new AlreadyLoadingError("Error button clicked");
                  }}
                >
                  JS AlreadyLoadingError
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    ApiService.exceptionErrorViewSet();
                  }}
                >
                  API Uncaught Exception
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    ApiService.apiExceptionErrorViewSet();
                  }}
                >
                  API Exception
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    ApiService.permissionDeniedErrorViewSet();
                  }}
                >
                  API Permission Denied
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    ApiService.timeoutErrorViewSet();
                  }}
                >
                  API Timeout
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
      {canChangeStations && (
        <>
          <ChangeStationModal
            isOpen={isChangingStation}
            close={() => setIsChangingStation(false)}
            canChangeLabs={canChangeLabs}
          />
          <button
            id="button-lis-change-stations"
            onClick={() => setIsChangingStation(!isChangingStation)}
          >
            <DesktopComputerIcon />
          </button>
        </>
      )}
      <button
        id="button-lis-logout"
        onClick={() => {
          dispatch(logout());
        }}
      >
        <UserRemoveIcon />
      </button>
    </div>
  );
};

export default StationButtons;
